module.exports = __webpack_public_path__ + "img/01.6b0fa41d.svg";